import React from 'react';
import { FamilyMember } from 'types/censusService';
import { observer } from 'mobx-react-lite';
import CensusTableCellComponent from '../TableCell';
import { NumberTableCellStyled, TableRowStyled } from './styles';
import { CENSUS_TABLE_ROW_TEST_ID } from '../../../constants';

export interface Props {
  familyMember: FamilyMember;
  cellIndex: number;
  familyIndex: number;
  isMoreThanOneFile: boolean;
  isLastFamilyMember: boolean;
}

const CensusTableRow: React.FC<Props> = observer(
  ({ familyMember, isMoreThanOneFile, familyIndex, isLastFamilyMember }) => {
    const { row, cells, status } = familyMember;
    const rowNumber = isMoreThanOneFile ? row : row.substring(2); // Cut 1- from row number if only one file uploaded

    return (
      <TableRowStyled
        $status={status}
        $familyIndex={familyIndex}
        $isLastFamilyMember={isLastFamilyMember}
        data-test-id={CENSUS_TABLE_ROW_TEST_ID}
      >
        <NumberTableCellStyled $status={status}>{rowNumber}</NumberTableCellStyled>
        {cells.map(({ value, errorMessage, warningMessage }, index): React.ReactNode => {
          return (
            <CensusTableCellComponent
              // eslint-disable-next-line react/no-array-index-key
              key={`${row}-${index}`}
              value={value}
              errorMessage={errorMessage}
              warningMessage={warningMessage}
            />
          );
        })}
      </TableRowStyled>
    );
  },
);

export default CensusTableRow;
